import { isLoggedIn, logOut, getUserEmail } from "./components/utils/auth";
export default {

    state: {
        isLoggedIn: false,
        userEmail:null,
        user: {},
        categories:[],
        usersList:[],
        filteredUsersList: [],
        message:null,
        success:false,
        error: false,
        useProducts: false,
        useAdmin: true,
        useLocale: false,
        icons:[],
        priceDeviationAdmins: [ // DO NOT MODIFY UNLESS DIRECTED TO. WILL GIVE USER ADMIN PRIVILEGES BEYOND BASIC ACCESS
            30, // Jeff Schwoeppe
            33, // Tom Winkler
            68, // Kyle Lekkas
            93, // Julia Joedicke
            21196, // Lisa Singh
            21201, // Cory Dinon
            21212, // Ricky Meyers
            21246, // Kevin Box
            21247, // Dan Taft
            21248, // Carl Frederick
        ],
        priceERPAdmins: [ // DO NOT MODIFY UNLESS DIRECTED TO. WILL GIVE USER ADMIN PRIVILEGES BEYOND BASIC ACCESS
            33, // Tom Winkler
            68, // Kyle Lekkas
            93, // Julia Joedicke
            21196, // Lisa Singh
            21201, // Cory Dinon
            21212, // Ricky Meyers
            21246, // Kevin Box
            21247, // Dan Taft
        ],
    },
    mutations: {
        setUser(state,payload){
            state.user=payload;
        },
        setUsersList(state,payload){
            state.usersList=payload;
        },
        setFilteredUsersList(state,payload){
            state.filteredUsersList=payload;
        },
        setLoggedIn(state,payload){
            state.isLoggedIn=payload;
        },
        setUserEmail(state,payload){
            state.userEmail=payload;
        },
        loadCategories(state, payload) {
            state.categories = payload;
        },
        loadIcons(state, payload) {
            state.icons = payload;
        },

    },
    getters:{
        getUser:state=>{
            return state.user;
        },

    },
    actions: {
        async loadStoredState(context){
            context.commit("setLoggedIn", isLoggedIn());
            context.commit("setUserEmail", getUserEmail());

            // loading user detail if the user is logged in
            if(isLoggedIn()){
                try {
                    const user= (await axios.get('/user')).data;
                    localStorage.setItem("approved", user.approved);
                    localStorage.setItem("userType", user.user_group_id);

                } catch (error) {
                    dispatch("logout");
                }
            }
        },
        // async loadCategories({ commit, state }) {
        //     const response = await axios.get(
        //         "/api/categories"
        //     );

        //     var result=response.data;
        //     // get the unique select code id
        //     var selectCodeList=[...new Set(result.map((item)=> item.select_code_id))];
        //     var category=[];

        //     // get the unique commodity code id based on the select code id
        //     for(var i=0;i<selectCodeList.length;i++){
        //         var commodityCodeList=[];
        //         var commodityCode=[];


        //         commodityCodeList=result.filter(function(item){
        //             if(item.select_code_id==selectCodeList[i]){ return item;  }
        //         }).map((item)=>item.commodity_code_id);

        //         // get the commodity code title
        //         for(var j=0; j<commodityCodeList.length; j++){
        //             var commodityCodeInfo={
        //                 "id": commodityCodeList[j],
        //                 "title":result.find(item=>item.commodity_code_id==commodityCodeList[j]).commodity_code.title
        //             };
        //             commodityCode.push(commodityCodeInfo);
        //         }

        //         // list all the select code and commodity code
        //         category.push({
        //             "select_code":{
        //                 "id":selectCodeList[i],
        //                 "title": result.find(item=>item.select_code_id==selectCodeList[i]).select_code.title
        //                 },
        //             "commodity_code": commodityCode
        //         });
        //     }

        //     // sorting category and subcategory in alphabetical order
        //     category.sort(function(category1,category2){
        //         var textA = category1.select_code.title.toUpperCase();
        //         var textB = category2.select_code.title.toUpperCase();
        //         return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        //     });

        //     category.forEach(function sortCommodity(subCategory, index){
        //         subCategory.commodity_code.sort(function(subcategory1,subcategory2){
        //             var textA = subcategory1.title.toUpperCase();
        //             var textB = subcategory2.title.toUpperCase();
        //             return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        //         });
        //     });

        //     commit('loadCategories',  category);

        // },
        // loadUsersList({ commit}){
        //     axios.get(`/api/user`)
        //     .then(response=> {
        //         commit("setUsersList",response.data);
        //         const filteredList=response.data.filter(user=>{
        //             return user.archive==0;
        //         });
        //         commit("setFilteredUsersList",filteredList);
        //     });
        // },
        // verifyUserList({ commit,state, dispatch}) {

        //     const filteredList = state.usersList.filter(user => {
        //         return (
        //             user.role.toLowerCase() == "customer" && user.archive == 0
        //         );
        //     });
        //     commit("setFilteredUsersList", filteredList);
        // },
        // archiveUserList({ commit,state}) {

        //     const filteredList = state.usersList.filter(user => {
        //         return user.archive == 1;
        //     });
        //     commit("setFilteredUsersList", filteredList);
        // },

        // async archiveVerifyUser({ commit, state, dispatch }, payload){
        //     await axios.post(`/api/user/archive/`, payload).then((response) => {
        //         state.message="The user has been archived.";
        //         state.success=true;
        //         state.error=false;
        //         var self=state;
        //         setTimeout(function(){
        //             self.success=false;
        //         }, 2000);
        //         axios.get(`/api/user`).then(response=> {
        //             commit("setUsersList",response.data);
        //             const filteredList=response.data.filter(user=>{
        //                 return user.role.toLowerCase() == "customer" && user.archive == 0;
        //             });
        //             commit("setFilteredUsersList",filteredList);
        //         });

        //     });
        // },
        // async archiveUser({ commit, state, dispatch }, payload){
        //     await axios.post(`/api/user/archive/`, payload).then((response) => {
        //         state.message="The user has been archived.";
        //         state.success=true;
        //         state.error=false;
        //         var self=state;
        //         setTimeout(function(){
        //             self.success=false;
        //         }, 2000);
        //         axios.get(`/api/user`).then(response=> {
        //             commit("setUsersList",response.data);
        //             const filteredList=response.data.filter(user=>{
        //                 return user.archive == 0;
        //             });
        //             commit("setFilteredUsersList",filteredList);
        //         });

        //     });
        // },

        // approveUser({ commit, state, dispatch }, payload){
        //     if(payload.role=='customer'){
        //         state.message="Please choose a different user role.";
        //         state.error=true;
        //         state.success=false;
        //         var self=state;
        //         setTimeout(function(){
        //             self.error=false;
        //         }, 3000);

        //     }else{
        //         axios.post(`/api/user/approve/`, payload).then((response) => {
        //             state.message="The user has been approved";
        //             state.success=true;
        //             state.error=false;
        //             var self=state;
        //             setTimeout(function(){
        //                 self.success=false;
        //             }, 3000);
        //             axios.get(`/api/user`).then(response=> {
        //                 commit("setUsersList",response.data);
        //                 const filteredList=response.data.filter(user=>{
        //                     return user.role.toLowerCase() == "customer" && user.archive == 0;
        //                 });
        //                 commit("setFilteredUsersList",filteredList);
        //             });

        //         });
        //     }

        // },
        // restoreUser({ commit, state, dispatch }, payload){
        //     if(payload.role=='customer'){
        //         state.message="Please choose a different user role.";
        //         state.error=true;
        //         state.success=false;
        //         var self=state;
        //         setTimeout(function(){
        //             self.error=false;
        //         }, 3000);
        //     }else{
        //         axios.post(`/api/user/approve/`, payload).then((response) => {
        //             state.message="The user has been approved.";
        //             state.success=true;
        //             state.error=false;
        //             var self=state;
        //             setTimeout(function(){
        //                 self.success=false;
        //             }, 3000);
        //             axios.get(`/api/user`).then(response=> {
        //                 commit("setUsersList",response.data);
        //                 const filteredList=response.data.filter(user=>{
        //                     return user.archive==1;
        //                 });
        //                 commit("setFilteredUsersList",filteredList);
        //             });

        //         });


        //     }

        // },
        async loadUser({commit, dispatch}){
            if(isLoggedIn()){
                try {
                    const user= (await axios.get('/user')).data;
                    commit("setUserEmail", user.email);
                    commit("setUser", user);
                    commit("setLoggedIn", true);


                } catch (error) {
                    dispatch("logout");
                }
            }
        },
        logout({commit}){
            commit("setUser", {});
            commit("setLoggedIn", false);
            commit("setUserEmail", null);
            logOut();
        },

        loadIcons({commit,state}){
            axios.get(`/api/productIcons`).then((response)=>{
                commit('loadIcons',  response.data);
            })

        },

    },
};
